import * as React from 'react';
import {
    ShowBase,
    useShowContext,
    ReferenceField,
    TextField
} from 'react-admin';
import { Box, Card, CardContent, Typography, Divider, Chip, Stack } from '@mui/material';

import { UserAside } from './UserAside';
import { User } from '@/types';

export const UserShow = () => (
    <ShowBase queryOptions={{ meta: { includes: 'user_credit_cards' } }}>
        <UserShowContent />
    </ShowBase>
);

const UserShowContent = () => {
    const { record, isPending } = useShowContext<User>();
    if (isPending || !record) return null;

    const creditCards = record.credit_cards ?? [];

    return (
        <Box mt={2} mb={2} display="flex">
            <UserAside />
            <Box flex="1">
                <Card>
                    <CardContent>
                        <Box display="flex">
                            <Box ml={2} flex="1" sx={{ mb: 2 }}>
                                <Typography variant="h5">
                                    {record.name}
                                </Typography>
                                <Typography variant="body1" component="div">
                                    {record.email}
                                </Typography>
                                <br />
                                <Typography variant="body2" component="div">
                                    <strong>Is Active?</strong> {record.is_active ? 'Active' : 'Inactive'}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Is Superuser?</strong> {record.is_superuser ? 'Superuser' : 'Not superuser'}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Can sign contracts?</strong> {record.can_sign ? 'Yes' : 'No'}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Role: </strong>
                                    <ReferenceField
                                        source="role_id"
                                        reference="roles"
                                        link="show"
                                    >
                                        <TextField source="name" />
                                    </ReferenceField>
                                </Typography>
                                <Divider sx={{ my: 2 }} />
                                <Typography variant="h6" gutterBottom>
                                    Credit Cards
                                </Typography>
                                {creditCards.length === 0 ? (
                                    <Typography variant="body2" color="text.secondary">
                                        No credit cards on file
                                    </Typography>
                                ) : (
                                    <Stack direction="row" flexWrap="wrap" gap={1}>
                                        {creditCards.map(card => (
                                            <Chip
                                                key={card.id ?? card.last_four}
                                                label={`•••• ${card.last_four}`}
                                                size="small"
                                            />
                                        ))}
                                    </Stack>
                                )}
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};
